import { render } from "./Index.vue?vue&type=template&id=7a9769ef"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Agencies/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a9769ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a9769ef', __exports__)) {
    api.reload('7a9769ef', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=7a9769ef", () => {
    api.rerender('7a9769ef', render)
  })

}


export default __exports__